import React from 'react';

const NoImageIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="74" viewBox="0 0 100 74">
    <g fill="none" fillRule="evenodd">
      <g fill="#FFF">
        <path
          d="M150 63v74H50V63h100zm-8 8H58v58h84V71zm-34.008 17.34l20.772 32.45H71.492l15.914-24.302 10.872 8.076 9.714-16.224zM77 79c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6z"
          transform="translate(-330 -235) translate(260 156) translate(20 16)"
        />
      </g>
    </g>
  </svg>
);

export default NoImageIcon;
